var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 100.0l-100.0 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 100.0l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m18.939968 44.316956l0 0c0 -17.464645 14.15789 -31.62254 31.622536 -31.62254l0 0c8.386818 0 16.430134 3.3316507 22.360508 9.262027c5.930382 5.930376 9.262032 13.973694 9.262032 22.360512l0 0c0 17.464645 -14.15789 31.622536 -31.62254 31.622536l0 0c-17.464645 0 -31.622536 -14.15789 -31.622536 -31.622536zm26.440868 0c0 2.8617554 2.319912 5.1816673 5.1816673 5.1816673c2.8617592 0 5.181671 -2.319912 5.181671 -5.1816673c0 -2.8617592 -2.319912 -5.181671 -5.181671 -5.181671l0 0c-2.8617554 0 -5.1816673 2.319912 -5.1816673 5.181671z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m31.954863 78.36068l37.460846 0l0 21.639618l-37.460846 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m70.34227 73.70126l0 0c0 12.325394 -8.831955 22.3171 -19.726723 22.3171c-10.894768 0 -19.726725 -9.991707 -19.726725 -22.3171l0 0c12.651384 5.800659 26.802065 5.800659 39.453445 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m12.53978 69.61028l17.63427 17.548836l0 4.07341l-21.727516 -21.622246z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m4.9744115 67.869835l0 0c0 -2.0871658 1.6919861 -3.779152 3.7791562 -3.779152l0 0c1.0022945 0 1.9635382 0.3981552 2.672267 1.1068878c0.70872974 0.708725 1.1068897 1.6699753 1.1068897 2.672264l0 0c0 2.0871735 -1.6919861 3.7791595 -3.7791567 3.7791595l0 0c-2.0871701 0 -3.7791562 -1.6919861 -3.7791562 -3.7791595z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3566CC",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m4.9744115 67.869835l0 0c0 -2.0871658 1.6919861 -3.779152 3.7791562 -3.779152l0 0c1.0022945 0 1.9635382 0.3981552 2.672267 1.1068878c0.70872974 0.708725 1.1068897 1.6699753 1.1068897 2.672264l0 0c0 2.0871735 -1.6919861 3.7791595 -3.7791567 3.7791595l0 0c-2.0871701 0 -3.7791562 -1.6919861 -3.7791562 -3.7791595z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m23.498737 21.571142l0 0c3.5017776 -4.18425 7.923168 -7.502632 12.91906 -9.696135l0.78918076 1.7974262l0 0c-4.7189217 2.0718956 -8.895187 5.2063065 -12.202827 9.158583z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m18.965353 20.187975c4.4805946 -5.894847 10.513407 -10.426343 17.423147 -13.087251l0.83807755 2.176283l0 0c-6.5057983 2.505351 -12.185934 6.7719355 -16.404593 12.322169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m14.2793455 19.086327l0 0c5.2112436 -7.5254307 12.6249895 -13.252481 21.222576 -16.394247l0.8855362 2.4233122l0 0c-8.097034 2.9588513 -15.079153 8.352472 -19.986998 15.439774z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m77.87184 21.573692l0 0c-3.5017776 -4.18425 -7.923172 -7.502634 -12.91906 -9.696136l-0.7891846 1.7974272l0 0c4.718918 2.0718946 8.895187 5.2063055 12.202827 9.158582z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m82.40522 20.190523c-4.480591 -5.894847 -10.513405 -10.426343 -17.423141 -13.08725l-0.83808136 2.176283l0 0c6.5057983 2.50535 12.185936 6.7719345 16.404594 12.322168z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "m87.09123 19.088877l0 0c-5.2112427 -7.5254316 -12.624992 -13.252483 -21.22258 -16.394247l-0.8855362 2.4233122l0 0c8.097038 2.9588513 15.079155 8.352472 19.987 15.439774z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarma);
export default __webpack_public_path__ + "static/media/alarma.48f2ffbc1ac186e25667fc6c9391979b.svg";
export { ForwardRef as ReactComponent };